export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "en-US",
    "Messages": {
        "${copied ? 'Skopiowano' : 'Kopiuj'}": "${copied ? 'Copied' : 'Copy'}",
        "${tokenVisibility ? 'Ukryj' : 'Pokaż'} token": "${tokenVisibility ? 'Hide' : 'Show'} token",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "To add team members, you must first save form.",
        "Administracja": "Administration",
        "Aktywna": "Active",
        "Aktywne źródła": "Active sources",
        "Aktywny": "Active",
        "Anuluj": "Cancel",
        "Bezpieczeństwo": "Security",
        "Brak wydziału": "No department",
        "Brak zdefiniowanych zespołów.": "No teams defined.",
        "Bramka SMS": "SMS gateway",
        "Czerwiec": "June",
        "Członkowie zespołu": "Team members",
        "Data do": "Date to",
        "Data dodania": "Date added",
        "Data od": "Date from",
        "Data opuszczenia zespołu": "Date of leaving team",
        "Data rozpoczęcia": "Start date",
        "Data utworzenia": "Creation date",
        "Data użycia": "Date of use",
        "Data wygaśnięcia": "Expiration date",
        "Data zakończenia": "End date",
        "Dodaj": "Add",
        "Dodaj do zespołu": "Add to team",
        "Dodaj dział": "Add department",
        "Dodaj token": "Add token",
        "Dodaj zastępstwo": "Add substitution",
        "Dodaj zespół": "Add team",
        "Dodaj źródło": "Add source",
        "Dodanie działu": "Adding department",
        "Dodanie zastępstwa": "Adding substitution",
        "Dodanie zespołu": "Adding team",
        "Dodanie źródła": "Adding source",
        "Domena": "Domain",
        "Dział aktywny": "Department active",
        "Dział nadrzędny": "Parent department",
        "Dział został dodany.": "Department has been added.",
        "Dział został usunięty.": "Department has been deleted.",
        "Dział został zaktualizowany.": "Department has been updated.",
        "Edycja działu": "edit department",
        "Edycja zastępstwa": "edit substitution",
        "Edycja zespołu": "edit team",
        "Edycja źródła": "edit source",
        "Edytuj": "Edit",
        "Edytuj członka grupy": "Edit group member",
        "Edytuj wpis": "Edit entry",
        "Filtr dla synchronizacji działów": "Filter for department synchronization",
        "Filtr dla synchronizacji użytkowników": "Filter for user synchronization",
        "Firebase": "Firebase",
        "Firebase config": "Firebase config",
        "Grudzień": "December",
        "Hasło": "Password",
        "Host": "Host",
        "Imię": "First name",
        "Imię i Nazwisko": "First and Last Name",
        "Inspekcja": "Inspection",
        "Jeśli danego użytkownika nie ma na liście, oznacza to, że brakuje podstawowych danych takich jak Imię i Nazwisko. Uzupełnij te dane w dziale Użytkownicy.": "If user is not on list, it means basic data such as First and Last Name are missing. Complete this data in Users section.",
        "Jeśli pole jest puste, wówczas używana jest wartość domyślna. W przeciwnym wypadku wartość domyślna jest nadpisywana.": "If field is empty, default value are used. Otherwise, default value are overwritten.",
        "Język": "Language",
        "Key": "Key",
        "Key pair": "Key pair",
        "Kolor drugorzędny: %0": "Secondary color: %0",
        "Kolor icon na panelu z aplikacjami: %0": "Icon color on application panel: %0",
        "Kolor podstawowy: %0": "Primary color: %0",
        "Kolor tekstu aktywnej pozycji menu: %0": "Text color of active menu item: %0",
        "Kolor tła panelu z aplikacjami: %0": "Background color of application panel: %0",
        "Kolory zostały przywrócone.": "Colors have been restored.",
        "Kolory zostały zapisane.": "Colors have been saved.",
        "Konta użytkowników zostały przypisane do zespołu": "User accounts have been assigned to team",
        "Kwiecień": "April",
        "LDAPS (LDAP over SSL)": "LDAPS (LDAP over SSL)",
        "Liczba wyników na stronie": "Number of results per page",
        "Lider": "Leader",
        "Lipiec": "July",
        "Listopad": "November",
        "Login": "Login",
        "Luty": "February",
        "Maj": "May",
        "Marzec": "March",
        "Miesiąc": "Month",
        "Moje konto": "My account",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Ability to modify this department is limited. Inactive fields are synchronized with external database %0.",
        "Nadawca": "Sender",
        "Narzędzie integruje się z platformą Firebase (powiadomienia push)": "Tool integrates with Firebase platform (push notifications)",
        "Narzędzie integruje się z platformą SMSAPI.pl": "Tool integrates with SMSAPI.pl platform",
        "Nazwa": "Name",
        "Nazwa działu": "Department name",
        "Nazwa użytkownika": "Username",
        "Nazwa zespołu": "Team name",
        "Nazwa źródła": "Source name",
        "Nazwisko": "Last name",
        "Nie": "No",
        "Nie masz dostępu do tego modułu": "You do not have access to this module",
        "Nie można przenosić wierszy pomiędzy gałęziami": "Rows cannot be moved between branches",
        "Nie udało się pobrać listy działów": "Failed to retrieve department list",
        "Nie udało się pobrać listy ról": "Failed to retrieve role list",
        "Nie udało się pobrać listy wydziałów": "Failed to retrieve faculty list",
        "Nie udało się pobrać listy zespołów": "Failed to retrieve team list",
        "Nie zdefiniowano żadnych ról.": "No roles defined.",
        "Nie znaleziono żadnych użytkowników.": "No users found.",
        "np. (&(objectClass=organizationalUnit))": "e.g. (&(objectClass=organizationalUnit))",
        "np. (&(objectClass=user)": "e.g. (&(objectClass=user)",
        "Opis": "Description",
        "Opis zespołu": "Team description",
        "Organizacja": "Organization",
        "Organizacja została usunięta.": "Organization has been deleted.",
        "Osoba zastępowana": "Replaced person",
        "Osoba zastępująca": "Substituting person",
        "Paleta kolorów": "Color palette",
        "Październik": "October",
        "Pole \"Liczba wyników na stronie\" jest wymagane.": "Field \"Number of results per page\" is required.",
        "Port": "Port",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Powrót": "back",
        "Predefiniowane tła panelu z aplikacjami": "Predefined application panel backgrounds",
        "Predefiniowane zestawy kolorów": "Predefined color sets",
        "Przetestuj ustawienia Sms": "Test Sms settings",
        "Przykład: domena\\użytkownik": "Example: domain\\user",
        "Przykład: użytkownik": "Example: user",
        "Przykład: użytkownik@domena": "Example: user@domain",
        "Przypisanie do zespołu": "Assignment to team",
        "Przywróć domyślne": "Restore default",
        "Rok": "Year",
        "Role i uprawnienia": "Roles and privileges",
        "Role zespołu": "Team roles",
        "Root": "Root",
        "SenderId": "SenderId",
        "Sierpień": "August",
        "Strona główna": "Home page",
        "Styczeń": "January",
        "System": "System",
        "Tak": "Yes",
        "Testowy numer telefonu": "Test phone number",
        "Token": "Token",
        "Token został usunięty.": "Token has been deleted.",
        "Tokeny": "Tokens",
        "Tokeny dostępu": "Access tokens",
        "Twój token": "Your token",
        "Tylko liderzy": "Leaders only",
        "Typ logowania": "Login type",
        "Uprawnienia": "Privileges",
        "Ustawienia": "Settings",
        "Ustawienia konta": "Account settings",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usuń": "delete",
        "Usuń dział": "Delete department",
        "Usuń z zespołu": "Remove from team",
        "Utwórz grupy": "Create groups",
        "Uwzględnij wydziały podrzędne": "Include child faculties",
        "Użytkownicy": "Users",
        "Użytkownik": "User",
        "Użytkownik jest liderem zespołu": "User is team leader",
        "Użytkownik nie należy do żadnego zespołu.": "User does not belong to any team.",
        "Użytkownik został dodany do zespołu.": "User has been added to team.",
        "W organizacji nie ma jeszcze żadnych działów.": "There are no departments in organization yet.",
        "W zespole od %0": "In team since %0",
        "W zespole od %0 do %1": "In team from %0 to %1",
        "Wartość domyślna: (&(objectClass=organizationalUnit))": "Default value: (&(objectClass=organizationalUnit))",
        "Wartość domyślna: (&(objectClass=user)": "Default value: (&(objectClass=user)",
        "Wiadomość testowa została wysłana.": "Test message has been sent.",
        "Wpis został zaktualizowany.": "Entry has been updated.",
        "Wrzesień": "September",
        "Wybierz opcję": "Select option",
        "Wybierz użytkownika": "Select user",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "Select users for whom you want to perform actions",
        "Wydział": "Faculty",
        "wyszukaj użytkownika...": "search user...",
        "Zablokowany": "Blocked",
        "zacznij pisać aby wyszukać użytkownika...": "start typing to search user...",
        "Zamknij": "Close",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and go back",
        "Zastępstwa": "Substitutions",
        "Zastępstwo wygasło.": "Substitution has expired.",
        "Zastępstwo wygaśnie za 10 minut.": "Substitution will expire in 10 minutes.",
        "Zastępstwo wygaśnie za 5 minut.": "Substitution will expire in 5 minutes.",
        "Zastępstwo wygaśnie za minutę.": "Substitution will expire in a minute.",
        "Zastępstwo zostało dodane.": "Substitution has been added.",
        "Zastępstwo zostało usunięte.": "Substitution has been deleted.",
        "Zastępstwo zostało zaktualizowane.": "Substitution has been updated.",
        "Zastępuje osobę": "Substitutes for person",
        "Zawiera": "Contains",
        "Zespoły": "Teams",
        "Zespół": "Team",
        "Zespół aktywny": "Team active",
        "Zespół został dodany.": "Team has been added.",
        "Zespół został usunięty.": "Team has been deleted.",
        "Zespół został zaktualizowany.": "Team has been updated.",
        "Zmień widok": "Change view",
        "Zobacz wszystkie zastępstwa": "View all substitutions",
        "Źródła LDAP": "LDAP sources",
        "Źródło aktywne": "Source active",
        "Źródło LDAP zostało dodane.": "LDAP source has been added.",
        "Źródło LDAP zostało zaktualizowane.": "LDAP source has been updated.",
        "Źródło zostało usunięte.": "Source has been deleted."
    }
};
